"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculatorComponent = void 0;
const core_1 = require("@angular/core");
const common_1 = require("@angular/common");
let CalculatorComponent = class CalculatorComponent {
    constructor() {
        this.display = (0, core_1.signal)('0');
        this.currentVal = '';
        this.operator = null;
        this.firstOperand = null;
        this.waitingForSecondOperand = false;
        this.buttons = [
            'C', '±', '%', '/',
            '7', '8', '9', '*',
            '4', '5', '6', '-',
            '1', '2', '3', '+',
            '0', '.', '='
        ];
    }
    isOperator(btn) {
        return ['/', '*', '-', '+', '='].includes(btn);
    }
    isSpecial(btn) {
        return ['C', '±', '%'].includes(btn);
    }
    onButtonClick(btn) {
        if (!isNaN(Number(btn)) || btn === '.') {
            this.handleNumber(btn);
        }
        else if (this.isOperator(btn)) {
            this.handleOperator(btn);
        }
        else {
            this.handleSpecial(btn);
        }
    }
    handleNumber(num) {
        if (this.waitingForSecondOperand) {
            this.currentVal = num;
            this.waitingForSecondOperand = false;
        }
        else {
            this.currentVal = this.currentVal === '0' && num !== '.' ? num : this.currentVal + num;
        }
        this.display.set(this.currentVal);
    }
    handleOperator(op) {
        const inputValue = parseFloat(this.currentVal);
        if (this.operator && this.waitingForSecondOperand) {
            this.operator = op;
            return;
        }
        if (this.firstOperand === null) {
            this.firstOperand = inputValue;
        }
        else if (this.operator) {
            const result = this.calculate(this.firstOperand, inputValue, this.operator);
            this.display.set(String(result));
            this.firstOperand = result;
        }
        this.waitingForSecondOperand = true;
        this.operator = op === '=' ? null : op;
        this.currentVal = this.display();
    }
    handleSpecial(btn) {
        switch (btn) {
            case 'C':
                this.reset();
                break;
            case '±':
                this.currentVal = String(parseFloat(this.currentVal) * -1);
                this.display.set(this.currentVal);
                break;
            case '%':
                this.currentVal = String(parseFloat(this.currentVal) / 100);
                this.display.set(this.currentVal);
                break;
        }
    }
    calculate(a, b, op) {
        switch (op) {
            case '+': return a + b;
            case '-': return a - b;
            case '*': return a * b;
            case '/': return a / b;
            default: return b;
        }
    }
    reset() {
        this.display.set('0');
        this.currentVal = '0';
        this.operator = null;
        this.firstOperand = null;
        this.waitingForSecondOperand = false;
    }
};
exports.CalculatorComponent = CalculatorComponent;
exports.CalculatorComponent = CalculatorComponent = __decorate([
    (0, core_1.Component)({
        selector: 'app-calculator',
        changeDetection: core_1.ChangeDetectionStrategy.OnPush,
        imports: [common_1.CommonModule],
        template: `
    <div class="h-full w-full flex flex-col bg-zinc-800 p-2 text-white select-none">
      <div class="display flex-grow flex items-end justify-end p-4 bg-zinc-900 rounded-md mb-2">
        <span class="text-5xl font-light">{{ display() }}</span>
      </div>
      <div class="buttons grid grid-cols-4 gap-2">
        @for (btn of buttons; track btn) {
          <button
            (click)="onButtonClick(btn)"
            class="h-16 rounded text-2xl"
            [class.bg-zinc-700]="isSpecial(btn)"
            [class.hover:bg-zinc-600]="isSpecial(btn)"
            [class.bg-orange-500]="isOperator(btn)"
            [class.hover:bg-orange-400]="isOperator(btn)"
            [class.bg-zinc-600]="!isSpecial(btn) && !isOperator(btn)"
            [class.hover:bg-zinc-500]="!isSpecial(btn) && !isOperator(btn)"
            [class.col-span-2]="btn === '0'"
          >
            {{ btn }}
          </button>
        }
      </div>
    </div>
  `
    })
], CalculatorComponent);
